const setupV3Rails = (root = document) => {
  root.querySelectorAll('[data-fp-v3-carousel]').forEach((carousel) => {
    if (carousel.dataset.fpV3Ready === 'true') return;
    const track = carousel.querySelector('[data-fp-v3-track]');
    if (!track) return;
    carousel.dataset.fpV3Ready = 'true';
    const progress = carousel.querySelector('[data-fp-v3-rail-progress]');
    const updateProgress = () => {
      if (!progress) return;
      const scrollable = Math.max(track.scrollWidth - track.clientWidth, 0);
      const ratio = scrollable > 0 ? Math.min(Math.max(track.scrollLeft / scrollable, 0), 1) : 0;
      progress.parentElement.hidden = scrollable < 2;
      progress.style.insetInlineStart = `${ratio * 69}%`;
    };
    carousel.querySelector('[data-fp-v3-previous]')?.addEventListener('click', () => {
      track.scrollBy({ left: -Math.max(track.clientWidth * 0.82, 260), behavior: 'smooth' });
    });
    carousel.querySelector('[data-fp-v3-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: Math.max(track.clientWidth * 0.82, 260), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateProgress, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      track.scrollBy({ left: event.key === 'ArrowLeft' ? -track.clientWidth * 0.82 : track.clientWidth * 0.82, behavior: 'smooth' });
    });
    window.addEventListener('resize', updateProgress, { passive: true });
    requestAnimationFrame(updateProgress);
  });
};

const savedProductsKey = 'fp-v3-saved-products';

const readSavedProducts = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(savedProductsKey) || '[]');
    return Array.isArray(saved) ? saved : [];
  } catch (_error) {
    return [];
  }
};

const writeSavedProducts = (saved) => {
  try {
    localStorage.setItem(savedProductsKey, JSON.stringify(saved));
  } catch (_error) {
    // Browsing and purchasing remain fully usable when storage is unavailable.
  }
};

const setupV3SaveButtons = (root = document) => {
  const saved = new Set(readSavedProducts());
  root.querySelectorAll('[data-fp-v3-save-product]').forEach((button) => {
    const handle = button.dataset.fpV3SaveProduct;
    const title = button.dataset.fpV3ProductTitle || 'product';
    const syncButton = () => {
      const isSaved = saved.has(handle);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', `${isSaved ? 'Remove' : 'Save'} ${title}${isSaved ? ' from saved items' : ''}`);
    };
    syncButton();
    if (button.dataset.fpV3SaveReady === 'true') return;
    button.dataset.fpV3SaveReady = 'true';
    button.addEventListener('click', () => {
      if (saved.has(handle)) saved.delete(handle);
      else saved.add(handle);
      writeSavedProducts([...saved]);
      syncButton();
      document.dispatchEvent(new CustomEvent('fp-v3:saved-products-change', { detail: { handles: [...saved] } }));
    });
  });
};

// The merchant preview toolbar overlays the page without reducing its viewport.
// Reserve its visible height so the entrance actions also fit during review.
let previewBarObserver;
const setupV3HeroViewport = () => {
  if (previewBarObserver || !document.querySelector('.fp-v3-hero')) return;
  let previewBar;
  const updateHeight = () => {
    const height = previewBar?.getBoundingClientRect().height || 0;
    // Opening the toolbar's full-screen menus must not collapse the hero.
    if (height > window.innerHeight / 2) return;
    document.body.style.setProperty('--fp-preview-bar-height', `${Math.ceil(height)}px`);
  };
  const resizeObserver = new ResizeObserver(updateHeight);
  const findPreviewBar = () => {
    const nextBar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
    if (nextBar === previewBar) return;
    resizeObserver.disconnect();
    previewBar = nextBar;
    if (previewBar) resizeObserver.observe(previewBar);
    updateHeight();
  };
  previewBarObserver = new MutationObserver(findPreviewBar);
  previewBarObserver.observe(document.body, { childList: true });
  findPreviewBar();
};

setupV3HeroViewport();
setupV3Rails();
setupV3SaveButtons();
document.addEventListener('shopify:section:load', (event) => {
  setupV3HeroViewport();
  setupV3Rails(event.target);
  setupV3SaveButtons(event.target);
});
